import { z } from 'zod'

/**
 * coupon code schema
 */
export const couponCodeSchema = z.object({
  coupon_code: z.string().trim().optional(),
})

// 导出 coupon code 表单类型
export type TCouponCodeSchema = z.infer<typeof couponCodeSchema>
